module.exports = __webpack_public_path__ + "single-property-cover.d3810ac.png";